<template>
    <div id="RequestViewerForPrint">
        <RequestFormForPrint
            v-bind:isLoading="requestLoading"
            v-bind:vfgSchema="localRequestSchema"
            v-bind:vfgModel="requestData"
        >
            <template v-if="requestData.mainData" v-slot:header>
                <div class="header_container clearfix">
                    <div class="header_title block">
                        <h2
                            style="color:#1976D2;"
                        >{{$t('Заявка')}} №{{requestData.mainData.requestNumber}} ({{requestData.mainData.requestType}})</h2>
                    </div>
                    <div class="main_data2 block" style="padding: 0px">
                        <div>
                            <div v-if="requestData.mainData.author">
                                <p class="label">{{$t('Автор')}}</p>
                                <p class="value">{{requestData.mainData.author}}</p>
                            </div>
                            <div v-if="requestData.mainData.createDateTime">
                                <p class="label">{{$t('Дата создания')}}</p>
                                <p
                                    class="value"
                                >{{requestData.mainData.createDateTime | formatDate}}</p>
                            </div>
                        </div>

                        <div>
                            <div v-if="requestData.mainData.status">
                                <p class="label">{{$t('Статус')}}</p>
                                <p class="value">{{requestData.mainData.status}}</p>
                            </div>
                            <div v-if="requestData.mainData.signedDateTime">
                                <p class="label">{{$t('Дата подписания')}}</p>
                                <p
                                    class="value"
                                >{{requestData.mainData.signedDateTime | formatDate}}</p>
                            </div>
                        </div>
                        <div>
                            <div v-if="signInfo.fio">
                                <p class="value">{{$t('Подписано ЭЦП')}}</p>
                                <p class="value">
                                    <label>{{$t('ИИН')}}:</label>
                                    {{signInfo.iin}}
                                </p>
                                <p class="value">
                                    <label>{{$t('ФИО')}}:</label>
                                    {{signInfo.fio}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </RequestFormForPrint>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import RequestFormForPrint from '../components/RequestFormForPrint';
import { BLOCK_METER_INDICATIONS_DATA_ONE, BLOCK_METER_INDICATIONS_DATA_TWO, BLOCK_METER_INDICATIONS, BLOCK_METER_INDICATIONS_DATA } from '../config/consts';

export default {
    name: 'RequestViewerForPrint',
    //props: ['requestId'],
    props: {
        requestId: {
            type: String
        },
        print: {
            type: Boolean,
            default: false
        }
    },
    components: { RequestFormForPrint },
    data: () => ({
        localRequestSchema: []
    }),
    watch: {
        requestId: function() {
            this.getRequest();
        }
    },
    computed: {
        ...mapGetters('request', ['visibleRequestSchema']),
        ...mapState('request', ['requestLoading', 'requestData', 'signInfo'])
    },
    methods: {
        ...mapActions('request', ['getRequestForView', 'getDocumentSignInfo']),
        async getRequest() {
            if (this.requestId) {
                this.getDocumentSignInfo(this.requestId);
                await this.getRequestForView(this.requestId);
                this.localRequestSchema = this.visibleRequestSchema;
                let one = this.localRequestSchema.find(schema => schema.code === BLOCK_METER_INDICATIONS_DATA_ONE);
                let two = this.localRequestSchema.find(schema => schema.code === BLOCK_METER_INDICATIONS_DATA_TWO);
                if (one && two) {
                    if (this.requestData[BLOCK_METER_INDICATIONS_DATA][BLOCK_METER_INDICATIONS]) {
                        this.$set(two, 'hide', true);
                    } else {
                        this.$set(one, 'hide', true);
                    }
                }
            }
        }
    },
    async mounted() {
        //this.getRequest();
        await this.getRequest();
        if (this.print) {
            window.print();
            this.$router.back();
        }
    }
};
</script>
<style>
.header_container p {
    margin-bottom: 1px !important;
}
.header_container {
    padding: 10px;
}
.header_container .block {
    float: left;
    width: 50%;
    padding: 10px;
}
.clearfix::after {
    content: '';
    clear: both;
    display: table;
}
.header_container .label {
    font-size: 12px;
}
.header_container .value {
    margin-bottom: 5px !important;
    margin-left: 3px !important;
    font-size: 15px;
}
.header_container .main_data > div {
    display: inline-block;
    padding-left: 50px;
    vertical-align: top;
}
.value label {
    font-size: 12px;
}
* {
    box-sizing: border-box;
}
#RequestViewerForPrint {
    min-height: 500px;
}
#RequestViewerForPrint .elevation-12,
#RequestViewerForPrint .v-card {
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
}
.header_container .label2 {
    font-size: 12px;
}
.header_container .value2 {
    margin-bottom: 5px !important;
    margin-left: 3px !important;
    font-size: 15px;
}
.header_container .main_data2 > div {
    display: inline-block;
    padding-left: 20px;
    vertical-align: top;
}
.value2 label {
    font-size: 12px;
}
</style>